import router from './router'
import store from './store'
import { getToken } from '@/utils/auth'


// 配置NProgress（保留基础加载条）
// NProgress.configure({ showSpinner: false })

// 免登录白名单（保留核心，可根据实际需求删减）
const whiteList = ['/login',]

router.beforeEach((to, from, next) => {
//   NProgress.start() // 启动加载条

  // 核心逻辑：判断是否有token
  if (getToken()) {
    // 有token的情况
    if (to.path === '/login' || to.path === '/shopLogin') {
      // 已登录但访问登录页，重定向到首页
      next({ path: '/' })
    //   NProgress.done()
    } else {
      if (!store.getters.roles || store.getters.roles.length === 0) {
        // 未拉取用户信息，执行GetInfo
        store.dispatch('GetInfo')
          .then(() => {
            next()
          })
          .catch((err) => {
            console.error('GetInfo 执行失败：', err)
            // 拉取失败，退出登录并重定向到登录页
            store.dispatch('LogOut').then(() => {
              next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
            //   NProgress.done()
            }).catch(err => {
                console.log(err)
            })
          })
      } else {
        // 已拉取用户信息，直接放行
        next()
      }
    }
  } else {
    // 无token的情况
    if (whiteList.includes(to.path)) {
      // 白名单页面，直接放行
      next()
    } else {
      // 非白名单页面，重定向到登录页
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
    //   NProgress.done()
    }
  }
})

router.afterEach(() => {
//   NProgress.done() // 结束加载条
})